export default __webpack_public_path__ + "static/media/created_by.1cb32881.svg";